import { httpPost } from "./httpService";

export function listAdminGraphs() {
  return httpPost("/admin/graph/v1/list", {});
}

export function createGraph(graphName) {
  return httpPost("/admin/graph/v1/create", { graphName });
}

export function renameGraph(id, graphName) {
  return httpPost("/admin/graph/v1/rename", { id, graphName });
}

export function disableGraph(id) {
  return httpPost("/admin/graph/v1/disable", { id });
}

export function enableGraph(id) {
  return httpPost("/admin/graph/v1/enable", { id });
}
